import site from '../data/site';
import './HoursTable.css';

export default function HoursTable() {
  return (
    <div className="ht">
      <h3 className="ht__title">Hours</h3>
      <p className="ht__lead">Restaurant + Market, same hours, all week long.</p>
      <table className="ht__table">
        <tbody>
          {site.hours.rows.map((r) => {
            const closed = r.hours.toLowerCase() === 'closed';
            return (
              <tr key={r.day} className={closed ? 'is-closed' : ''}>
                <th scope="row">{r.day}</th>
                <td>{r.hours}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
